// 1st/2nd Half Goals (Phase 3). Picks the view (bands default / bars); the view
// is toggled by a legacy button that flips `mod.dataset.hgView` and calls
// refreshModuleBody — arriving here as `view`. Flipping unmounts one child and
// mounts the other (matching the legacy rebuild). The bars child is keyed by
// fixture+team so those changes reset its fills.

import HalfGoalsBands from "./HalfGoalsBands.js";
import HalfGoalsBars from "./HalfGoalsBars.js";

export interface HalfGoalsProps {
  fixture: string;
  team?: string | null;
  timeline?: string | null;
  /** "bands" (default) | "bars". */
  view?: string | null;
}

export default function HalfGoals({ fixture, team, timeline, view }: HalfGoalsProps) {
  if (view === "bars") {
    const parts = (fixture || "Arsenal v Everton").split(" v ");
    const chosen = team || (parts[0] ?? "").trim();
    return (
      <HalfGoalsBars
        key={`${fixture}|${chosen}`}
        fixture={fixture}
        team={team}
        timeline={timeline}
      />
    );
  }
  return <HalfGoalsBands fixture={fixture} team={team} timeline={timeline} />;
}
